import ChooseCaptainMulti from '@/components/monaco/input/ChooseCaptainMulti';
import ChoosePermissionsMulti from "@/components/monaco/input/ChoosePermissionMulti";
import ChooseImage from "@/components/monaco/input/ChooseImage";
import ChooseCars from "@/components/monaco/input/ChooseCars";
import ChooseRole from "@/components/monaco/input/ChooseRole";
import ChooseGender from "@/components/monaco/input/ChooseGender";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import ChooseVoucher from "@/components/monaco/input/ChooseVoucher";
import ChooseTime from "@/components/monaco/input/ChooseTime";
import ChooseNumbers from "@/components/monaco/input/ChooseNumbers";
import ChooseBeeslineAreaCluster from "@/components/monaco/input/ChooseBeeslineAreaCluster";
import ChooseAppearanceConstrain from "@/components/monaco/input/ChooseAppearanceConstrain";
import ChooseLocationMulti from "@/components/monaco/input/ChooseLocationMulti";
import ChooseProject from "@/components/monaco/input/ChooseProject";
import {VSelect} from "vuetify/lib/components/VSelect";
import {VTextField} from "vuetify/lib/components/VTextField";
import {VueTagsInput} from "@johmun/vue-tags-input";
import ChooseLevel from "@/components/monaco/input/ChooseLevel";

export default {
    "choose-captains-multi": ChooseCaptainMulti,
    'choose-permissions-multi': ChoosePermissionsMulti,
    'choose-image-single': ChooseImage,
    'choose-cars': ChooseCars,
    'choose-role': ChooseRole,
    'choose-gender': ChooseGender,
    'choose-date': ChooseDate,
    'choose-voucher': ChooseVoucher,
    'choose-time': ChooseTime,
    'choose-numbers': ChooseNumbers,
    'choose-beesline-area-cluster': ChooseBeeslineAreaCluster,
    'choose-appearance-constrain' : ChooseAppearanceConstrain,
    'choose-locations' : ChooseLocationMulti,
    'choose-project': ChooseProject,
    'choose-level': ChooseLevel,
    "v-select" : VSelect,
    'v-text-field': VTextField,
    'vue-tags-input': VueTagsInput,
};

